<section class="page-stack terminal-page">
  <div class="crud-panel">
    <div class="crud-header">
      <div>
        <span class="eyebrow">msvc-management</span>
        <h2>{{ pageTitle }}</h2>
      </div>
      <button class="primary-button add-button" type="button" (click)="openCreate()" *ngIf="activeTab === 'pos-terminals'">+ Dar de alta</button>
      <button class="primary-button add-button" type="button" (click)="openMerchantCreate()" *ngIf="activeTab === 'merchant-id'">+ Dar de alta</button>
      <button class="primary-button add-button" type="button" (click)="openConditionCreate()" *ngIf="activeTab === 'condition-fee'">+ Dar de alta</button>
      <button class="primary-button add-button" type="button" (click)="openInstallmentCreate()" *ngIf="activeTab === 'installments'">+ Dar de alta</button>
      <button class="primary-button add-button" type="button" (click)="openPlanCreate()" *ngIf="activeTab === 'installments-plan'">+ Dar de alta</button>
      <button class="primary-button add-button" type="button" (click)="openPlanFactorCreate()" *ngIf="activeTab === 'plan-installments'">+ Dar de alta</button>
      <button class="primary-button add-button" type="button" (click)="openAssignPlanCreate()" *ngIf="activeTab === 'assign-plan'">+ Dar de alta</button>
      <button class="primary-button add-button" type="button" (click)="openTerminalPaywayCreate()" *ngIf="activeTab === 'terminal-payway'">+ Dar de alta</button>
      <button class="primary-button add-button" type="button" (click)="openVirtualCreate()" *ngIf="activeTab === 'virtual-terminal'">+ Dar de alta</button>
      <button class="primary-button add-button" type="button" (click)="openSubmerchantCreate()" *ngIf="activeTab === 'submerchant'">+ Dar de alta</button>
      <button class="primary-button add-button" type="button" (click)="openTerminalGPCreate()" *ngIf="activeTab === 'terminal-global-processing'">+ Dar de alta</button>
    </div>

    <nav class="terminal-tabs" aria-label="Secciones de terminales">
      <button
        class="terminal-tab"
        type="button"
        *ngFor="let tab of tabs"
        [class.active]="activeTab === tab.id"
        (click)="selectTab(tab.id)">
        {{ tab.label }}
      </button>
    </nav>

    <ng-container *ngIf="activeTab === 'pos-terminals'; else merchantIdTab">
      <div class="crud-tools terminal-tools">
        <input type="search" placeholder="Buscar terminal" [(ngModel)]="searchText" (keyup.enter)="applyFilters()">
        <input type="number" placeholder="ID terminal" [(ngModel)]="filters['id']">
        <input type="text" placeholder="Serial" [(ngModel)]="filters['serialNumber']">
        <input type="text" placeholder="Version" [(ngModel)]="filters['softwareVersion']">
        <select [(ngModel)]="filters['terminalStatus']">
          <option value="">Estado terminal</option>
          <option *ngFor="let status of statuses" [value]="status">{{ statusLabel(status) }}</option>
        </select>
        <select [(ngModel)]="filters['enabled']">
          <option value="">Habilitacion</option>
          <option value="true">Habilitadas</option>
          <option value="false">Deshabilitadas</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table terminals-table">
          <thead>
            <tr>
              <th>ID terminal</th>
              <th>Serial</th>
              <th>Version software</th>
              <th>Estado de Terminal</th>
              <th>Habilitacion</th>
              <th>Ultima modificacion</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows">
              <td>{{ terminalCode(row.id) }}</td>
              <td>{{ row.serialNumber || '-' }}</td>
              <td>{{ row.softwareVersion || '-' }}</td>
              <td>
                <span class="badge" [class.success]="row.terminalStatus === 'FUNCIONAL'" [class.warning]="row.terminalStatus !== 'FUNCIONAL'">
                  {{ statusLabel(row.terminalStatus) }}
                </span>
              </td>
              <td>
                <span class="badge" [class.success]="row.enabled" [class.danger]="!row.enabled">
                  {{ row.enabled ? 'Habilitada' : 'Deshabilitada' }}
                </span>
              </td>
              <td>{{ formatDate(row.updatedAt) }}</td>
              <td>
                <div class="row-actions">
                  <button class="action-button edit" type="button" title="Editar" (click)="openEdit(row)">✎</button>
                  <button class="action-button delete" type="button" title="Deshabilitar" (click)="disable(row)" [disabled]="!row.enabled">■</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!rows.length && !tableLoading">
              <td colspan="7">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ total }} de {{ totalRecords || total }} terminales
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="size" (ngModelChange)="changeSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changePage(page - 1)" [disabled]="page === 0">Anterior</button>
          <app-page-navigation [page]="page" [totalPages]="totalPages" [disabled]="tableLoading" (pageChange)="changePage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changePage(page + 1)" [disabled]="page + 1 >= totalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #merchantIdTab>
    <ng-container *ngIf="activeTab === 'merchant-id'; else conditionFeeTab">
      <div class="crud-tools merchant-tools">
        <input type="search" placeholder="Buscar merchant" [(ngModel)]="merchantSearchText" (keyup.enter)="applyMerchantFilters()">
        <input type="number" placeholder="ID" [(ngModel)]="merchantFilters['id']">
        <app-client-select [(ngModel)]="merchantFilters['clientId']"></app-client-select>
        <input type="text" placeholder="Merchant ID" [(ngModel)]="merchantFilters['merchantId']">
        <select [(ngModel)]="merchantFilters['acquirer']">
          <option value="">Adquirente</option>
          <option *ngFor="let acquirer of acquirers" [value]="acquirer">{{ acquirer }}</option>
        </select>
        <input type="text" placeholder="MCC" [(ngModel)]="merchantFilters['mcc']">
        <select [(ngModel)]="merchantFilters['cardBrand']">
          <option value="">Marca</option>
          <option *ngFor="let brand of cardBrands" [value]="brand">{{ brand }}</option>
        </select>
        <select [(ngModel)]="merchantFilters['paymentProcessType']">
          <option value="">Proceso</option>
          <option *ngFor="let type of paymentProcessTypes" [value]="type">{{ type }}</option>
        </select>
        <select [(ngModel)]="merchantFilters['enabled']">
          <option value="">Habilitacion</option>
          <option value="true">Habilitados</option>
          <option value="false">Deshabilitados</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearMerchantFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyMerchantFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table merchants-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th>Merchant ID</th>
              <th>Adquirente</th>
              <th>Descripcion</th>
              <th>MCC</th>
              <th>Marca</th>
              <th>Proceso</th>
              <th>Banco</th>
              <th>Habilitacion</th>
              <th>Ultima modificacion</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of merchantRows">
              <td>{{ row.id || '-' }}</td>
              <td>{{ row.clientId || '-' }}</td>
              <td>{{ row.merchantId || '-' }}</td>
              <td>{{ row.acquirer || '-' }}</td>
              <td>{{ row.descripcion || '-' }}</td>
              <td>{{ row.mcc || '-' }}</td>
              <td>{{ logicalCardBrand(row.cardBrand) }}</td>
              <td>{{ row.paymentProcessType || '-' }}</td>
              <td>{{ row.bankId || '-' }}</td>
              <td>
                <span class="badge" [class.success]="row.enabled" [class.danger]="!row.enabled">
                  {{ row.enabled ? 'Habilitado' : 'Deshabilitado' }}
                </span>
              </td>
              <td>{{ formatDate(row.updatedAt) }}</td>
              <td>
                <div class="row-actions">
                  <button class="action-button edit" type="button" title="Editar" (click)="openMerchantEdit(row)">✎</button>
                  <button
                    class="action-button"
                    [class.edit]="!row.enabled"
                    [class.delete]="row.enabled"
                    type="button"
                    [title]="row.enabled ? 'Deshabilitar' : 'Habilitar'"
                    (click)="toggleMerchantEnabled(row)">
                    {{ row.enabled ? '■' : '✓' }}
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!merchantRows.length && !tableLoading">
              <td colspan="11">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ merchantTotal }} merchant IDs
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="merchantSize" (ngModelChange)="changeMerchantSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changeMerchantPage(merchantPage - 1)" [disabled]="merchantPage === 0">Anterior</button>
          <app-page-navigation [page]="merchantPage" [totalPages]="merchantTotalPages" [disabled]="tableLoading" (pageChange)="changeMerchantPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changeMerchantPage(merchantPage + 1)" [disabled]="merchantPage + 1 >= merchantTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #conditionFeeTab>
    <ng-container *ngIf="activeTab === 'condition-fee'; else installmentsTab">
      <div class="crud-tools condition-tools">
        <input type="search" placeholder="Buscar por ID" [(ngModel)]="conditionSearchText" (keyup.enter)="applyConditionFilters()">
        <input type="number" placeholder="ID" [(ngModel)]="conditionFilters['id']">
        <select [(ngModel)]="conditionFilters['posMerchantId']">
          <option value="">Merchant ID</option>
          <option *ngFor="let merchant of merchantOptions" [ngValue]="merchant.id">{{ merchantOptionLabel(merchant.id) }}</option>
        </select>
        <select [(ngModel)]="conditionFilters['paymentType']">
          <option value="">Tipo de pago</option>
          <option *ngFor="let option of paymentTypes" [ngValue]="option">{{ option }}</option>
        </select>
        <select [(ngModel)]="conditionFilters['installmentType']">
          <option value="">Tipo de cuotas</option>
          <option *ngFor="let option of installmentTypes" [ngValue]="option">{{ option }}</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearConditionFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyConditionFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table condition-fee-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Merchant ID</th>
              <th>Tipo de pago</th>
              <th>Tipo de cuotas</th>
              <th>Tax</th>
              <th>Fee</th>
              <th>TNA</th>
              <th>Bank fee</th>
              <th>Ultima modificacion</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of conditionRows">
              <td>{{ row.id || '-' }}</td>
              <td>{{ merchantOptionLabel(row.posMerchantId) }}</td>
              <td>{{ row.paymentType || '-' }}</td>
              <td>{{ row.installmentType || '-' }}</td>
              <td>{{ row.tax ?? '-' }}</td>
              <td>{{ row.fee ?? '-' }}</td>
              <td>{{ row.tna ?? '-' }}</td>
              <td>{{ row.bankFee ?? '-' }}</td>
              <td>{{ formatDate(row.updatedAt) }}</td>
              <td>
                <div class="row-actions">
                  <button class="action-button edit" type="button" title="Editar" (click)="openConditionEdit(row)">✎</button>
                  <button class="action-button delete" type="button" title="Eliminar" (click)="deleteCondition(row)">■</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!conditionRows.length && !tableLoading">
              <td colspan="10">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ conditionTotal }} condiciones
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="conditionSize" (ngModelChange)="changeConditionSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changeConditionPage(conditionPage - 1)" [disabled]="conditionPage === 0">Anterior</button>
          <app-page-navigation [page]="conditionPage" [totalPages]="conditionTotalPages" [disabled]="tableLoading" (pageChange)="changeConditionPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changeConditionPage(conditionPage + 1)" [disabled]="conditionPage + 1 >= conditionTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #installmentsTab>
    <ng-container *ngIf="activeTab === 'installments'; else planTab">
      <div class="crud-tools installments-tools">
        <input type="search" placeholder="Buscar por ID" [(ngModel)]="installmentSearchText" (keyup.enter)="applyInstallmentFilters()">
        <input type="number" placeholder="ID" [(ngModel)]="installmentFilters['id']">
        <select [(ngModel)]="installmentFilters['posMerchantConditionFeeId']">
          <option value="">Condition fee</option>
          <option *ngFor="let option of installmentConditionFeeOptions" [ngValue]="option.id">{{ conditionFeeOptionLabel(option.id) }}</option>
        </select>
        <input type="number" placeholder="Nro cuotas" [(ngModel)]="installmentFilters['installmentNumber']">
        <select [(ngModel)]="installmentFilters['enable']">
          <option value="">Estado</option>
          <option value="true">Habilitados</option>
          <option value="false">Deshabilitados</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearInstallmentFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyInstallmentFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table installments-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Condition fee</th>
              <th>Factor</th>
              <th>Nro cuotas</th>
              <th>Inicio</th>
              <th>Estado</th>
              <th>Ultima modificacion</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of installmentRows">
              <td>{{ row.id || '-' }}</td>
              <td>{{ conditionFeeOptionLabel(row.posMerchantConditionFeeId) }}</td>
              <td>{{ row.installmentFactor ?? '-' }}</td>
              <td>{{ row.installmentNumber || '-' }}</td>
              <td>{{ row.start || '-' }}</td>
              <td>
                <span class="badge" [class.success]="row.enable" [class.danger]="!row.enable">
                  {{ row.enable ? 'Habilitado' : 'Deshabilitado' }}
                </span>
              </td>
              <td>{{ formatDate(row.updatedAt) }}</td>
              <td>
                <div class="row-actions">
                  <button class="action-button edit" type="button" title="Editar" (click)="openInstallmentEdit(row)">✎</button>
                  <button class="action-button delete" type="button" title="Deshabilitar" (click)="deleteInstallment(row)" [disabled]="!row.enable">■</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!installmentRows.length && !tableLoading">
              <td colspan="8">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ installmentTotal }} installments
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="installmentSize" (ngModelChange)="changeInstallmentSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changeInstallmentPage(installmentPage - 1)" [disabled]="installmentPage === 0">Anterior</button>
          <app-page-navigation [page]="installmentPage" [totalPages]="installmentTotalPages" [disabled]="tableLoading" (pageChange)="changeInstallmentPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changeInstallmentPage(installmentPage + 1)" [disabled]="installmentPage + 1 >= installmentTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #planTab>
    <ng-container *ngIf="activeTab === 'installments-plan'; else planFactorTab">
      <div class="crud-tools plan-tools">
        <input type="search" placeholder="Buscar plan" [(ngModel)]="planSearchText" (keyup.enter)="applyPlanFilters()">
        <input type="number" placeholder="ID" [(ngModel)]="planFilters['id']">
        <select [(ngModel)]="planFilters['posMerchantConditionFeeId']">
          <option value="">Condition fee</option>
          <option *ngFor="let option of installmentConditionFeeOptions" [ngValue]="option.id">{{ conditionFeeOptionLabel(option.id) }}</option>
        </select>
        <input type="text" placeholder="Descripcion" [(ngModel)]="planFilters['description']">
        <select [(ngModel)]="planFilters['enabled']">
          <option value="">Estado</option>
          <option value="true">Habilitados</option>
          <option value="false">Deshabilitados</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearPlanFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyPlanFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table plan-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Condition fee</th>
              <th>Descripcion</th>
              <th>Inicio</th>
              <th>Fin</th>
              <th>Estado</th>
              <th>Internacional</th>
              <th>Cargo cliente</th>
              <th>Recargo</th>
              <th>Max financiacion</th>
              <th>BINs</th>
              <th>Dias</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of planRows">
              <td>{{ row.id || '-' }}</td>
              <td>{{ conditionFeeOptionLabel(row.posMerchantConditionFeeId) }}</td>
              <td>{{ row.description || '-' }}</td>
              <td>{{ row.start || '-' }}</td>
              <td>{{ row.ending || '-' }}</td>
              <td>
                <span class="badge" [class.success]="row.enabled" [class.danger]="!row.enabled">
                  {{ row.enabled ? 'Habilitado' : 'Deshabilitado' }}
                </span>
              </td>
              <td>{{ row.internacional ? 'Si' : 'No' }}</td>
              <td>{{ row.clientFinancialCharge ? 'Si' : 'No' }}</td>
              <td>{{ row.surchargePercentage ?? '-' }}</td>
              <td>{{ row.maxFinancingAmount ?? '-' }}</td>
              <td>{{ listLabel(row.binList) }}</td>
              <td>{{ listLabel(row.dayList) }}</td>
              <td>
                <div class="row-actions">
                  <button class="action-button edit" type="button" title="Editar" (click)="openPlanEdit(row)">✎</button>
                  <button class="action-button delete" type="button" title="Deshabilitar" (click)="deletePlan(row)" [disabled]="!row.enabled">■</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!planRows.length && !tableLoading">
              <td colspan="13">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ planTotal }} planes
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="planSize" (ngModelChange)="changePlanSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changePlanPage(planPage - 1)" [disabled]="planPage === 0">Anterior</button>
          <app-page-navigation [page]="planPage" [totalPages]="planTotalPages" [disabled]="tableLoading" (pageChange)="changePlanPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changePlanPage(planPage + 1)" [disabled]="planPage + 1 >= planTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #planFactorTab>
    <ng-container *ngIf="activeTab === 'plan-installments'; else assignPlanTab">
      <div class="crud-tools plan-factor-tools">
        <input type="search" placeholder="Buscar installment" [(ngModel)]="planFactorSearchText" (keyup.enter)="applyPlanFactorFilters()">
        <input type="number" placeholder="ID" [(ngModel)]="planFactorFilters['id']">
        <select [(ngModel)]="planFactorFilters['posInstallmentsPlanId']">
          <option value="">Plan</option>
          <option *ngFor="let option of planOptions" [ngValue]="option.id">{{ planOptionLabel(option.id) }}</option>
        </select>
        <input type="number" placeholder="Nro cuotas" [(ngModel)]="planFactorFilters['installmentNumber']">
        <input type="text" placeholder="Texto comercial" [(ngModel)]="planFactorFilters['displayText']">
        <select [(ngModel)]="planFactorFilters['enabled']">
          <option value="">Estado</option>
          <option value="true">Habilitados</option>
          <option value="false">Deshabilitados</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearPlanFactorFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyPlanFactorFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table plan-factor-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Plan</th>
              <th>Factor</th>
              <th>Nro cuotas</th>
              <th>Texto comercial</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of planFactorRows">
              <td>{{ row.id || '-' }}</td>
              <td>{{ planOptionLabel(row.posInstallmentsPlanId) }}</td>
              <td>{{ row.installmentFactor ?? '-' }}</td>
              <td>{{ row.installmentNumber || '-' }}</td>
              <td>{{ row.displayText || '-' }}</td>
              <td>
                <span class="badge" [class.success]="row.enabled" [class.danger]="!row.enabled">
                  {{ row.enabled ? 'Habilitado' : 'Deshabilitado' }}
                </span>
              </td>
              <td>
                <div class="row-actions">
                  <button class="action-button edit" type="button" title="Editar" (click)="openPlanFactorEdit(row)">✎</button>
                  <button class="action-button delete" type="button" title="Deshabilitar" (click)="deletePlanFactor(row)" [disabled]="!row.enabled">■</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!planFactorRows.length && !tableLoading">
              <td colspan="7">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ planFactorTotal }} installments de planes
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="planFactorSize" (ngModelChange)="changePlanFactorSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changePlanFactorPage(planFactorPage - 1)" [disabled]="planFactorPage === 0">Anterior</button>
          <app-page-navigation [page]="planFactorPage" [totalPages]="planFactorTotalPages" [disabled]="tableLoading" (pageChange)="changePlanFactorPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changePlanFactorPage(planFactorPage + 1)" [disabled]="planFactorPage + 1 >= planFactorTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #assignPlanTab>
    <ng-container *ngIf="activeTab === 'assign-plan'; else terminalPaywayTab">
      <div class="crud-tools assign-plan-tools">
        <input type="search" placeholder="Buscar por ID" [(ngModel)]="assignPlanSearchText" (keyup.enter)="applyAssignPlanFilters()">
        <input type="number" placeholder="ID" [(ngModel)]="assignPlanFilters['id']">
        <app-client-select [(ngModel)]="assignPlanFilters['clientId']"></app-client-select>
        <select [(ngModel)]="assignPlanFilters['posInstallmentsPlanId']">
          <option value="">Plan</option>
          <option *ngFor="let option of planOptions" [ngValue]="option.id">{{ planOptionLabel(option.id) }}</option>
        </select>
        <select [(ngModel)]="assignPlanFilters['enabled']">
          <option value="">Estado</option>
          <option value="true">Habilitados</option>
          <option value="false">Deshabilitados</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearAssignPlanFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyAssignPlanFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table assign-plan-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th>Plan</th>
              <th>Estado</th>
              <th>Alta</th>
              <th>Ultima modificacion</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of assignPlanRows">
              <td>{{ row.id || '-' }}</td>
              <td>{{ row.clientId || '-' }}</td>
              <td>{{ planOptionLabel(row.posInstallmentsPlanId) }}</td>
              <td>
                <span class="badge" [class.success]="row.enabled" [class.danger]="!row.enabled">
                  {{ row.enabled ? 'Habilitado' : 'Deshabilitado' }}
                </span>
              </td>
              <td>{{ formatDate(row.createdAt) }}</td>
              <td>{{ formatDate(row.updatedAt) }}</td>
              <td>
                <div class="row-actions">
                  <button class="action-button edit" type="button" title="Editar" (click)="openAssignPlanEdit(row)">✎</button>
                  <button class="action-button delete" type="button" title="Deshabilitar" (click)="deleteAssignPlan(row)" [disabled]="!row.enabled">■</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!assignPlanRows.length && !tableLoading">
              <td colspan="7">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ assignPlanTotal }} asignaciones
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="assignPlanSize" (ngModelChange)="changeAssignPlanSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changeAssignPlanPage(assignPlanPage - 1)" [disabled]="assignPlanPage === 0">Anterior</button>
          <app-page-navigation [page]="assignPlanPage" [totalPages]="assignPlanTotalPages" [disabled]="tableLoading" (pageChange)="changeAssignPlanPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changeAssignPlanPage(assignPlanPage + 1)" [disabled]="assignPlanPage + 1 >= assignPlanTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #terminalPaywayTab>
    <ng-container *ngIf="activeTab === 'terminal-payway'; else virtualTerminalTab">
      <div class="crud-tools payway-tools">
        <input type="search" placeholder="Buscar terminal" [(ngModel)]="terminalPaywaySearchText" (keyup.enter)="applyTerminalPaywayFilters()">
        <input type="number" placeholder="ID" [(ngModel)]="terminalPaywayFilters['id']">
        <input type="text" placeholder="Terminal ID Payway" [(ngModel)]="terminalPaywayFilters['terminalId']">
        <select [(ngModel)]="terminalPaywayFilters['posVirtualTerminalId']">
          <option value="">Terminal virtual</option>
          <option *ngFor="let terminal of virtualTerminalOptions" [ngValue]="terminal.id">{{ virtualTerminalOptionLabel(terminal.id) }}</option>
        </select>
        <select [(ngModel)]="terminalPaywayFilters['posMerchantId']">
          <option value="">Merchant ID</option>
          <option *ngFor="let merchant of merchantOptions" [ngValue]="merchant.id">{{ merchantOptionLabel(merchant.id) }}</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearTerminalPaywayFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyTerminalPaywayFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table payway-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Terminal ID Payway</th>
              <th>Terminal virtual</th>
              <th>Merchant ID</th>
              <th>Ultima modificacion</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of terminalPaywayRows">
              <td>{{ row.id || '-' }}</td>
              <td>{{ row.terminalId || '-' }}</td>
              <td>{{ virtualTerminalOptionLabel(row.posVirtualTerminalId) }}</td>
              <td>{{ merchantOptionLabel(row.posMerchantId) }}</td>
              <td>{{ formatDate(row.updatedAt) }}</td>
              <td>
                <div class="row-actions">
                  <button class="action-button edit" type="button" title="Editar" (click)="openTerminalPaywayEdit(row)">✎</button>
                  <button class="action-button delete" type="button" title="Eliminar" (click)="deleteTerminalPayway(row)">■</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!terminalPaywayRows.length && !tableLoading">
              <td colspan="6">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ terminalPaywayTotal }} terminales Payway
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="terminalPaywaySize" (ngModelChange)="changeTerminalPaywaySize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changeTerminalPaywayPage(terminalPaywayPage - 1)" [disabled]="terminalPaywayPage === 0">Anterior</button>
          <app-page-navigation [page]="terminalPaywayPage" [totalPages]="terminalPaywayTotalPages" [disabled]="tableLoading" (pageChange)="changeTerminalPaywayPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changeTerminalPaywayPage(terminalPaywayPage + 1)" [disabled]="terminalPaywayPage + 1 >= terminalPaywayTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #virtualTerminalTab>
    <ng-container *ngIf="activeTab === 'virtual-terminal'; else configurationTab">
      <div class="crud-tools virtual-tools">
        <input type="search" placeholder="Buscar virtual" [(ngModel)]="virtualSearchText" (keyup.enter)="applyVirtualFilters()">
        <input type="number" placeholder="ID" [(ngModel)]="virtualFilters['id']">
        <input type="number" placeholder="POS terminal" [(ngModel)]="virtualFilters['posTerminalId']">
        <app-client-select [(ngModel)]="virtualFilters['clientId']"></app-client-select>
        <input type="text" placeholder="Terminal ID" [(ngModel)]="virtualFilters['terminalId']">
        <select [(ngModel)]="virtualFilters['terminalType']">
          <option value="">Tipo</option>
          <option *ngFor="let type of virtualTerminalTypes" [value]="type">{{ type }}</option>
        </select>
        <select [(ngModel)]="virtualFilters['status']">
          <option value="">Estado</option>
          <option *ngFor="let status of virtualStatuses" [value]="status">{{ statusLabel(status) }}</option>
        </select>
        <select [(ngModel)]="virtualFilters['enabled']">
          <option value="">Habilitacion</option>
          <option value="true">Habilitadas</option>
          <option value="false">Deshabilitadas</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearVirtualFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyVirtualFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table virtual-terminal-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>POS terminal</th>
              <th>Cliente</th>
              <th>Terminal virtual</th>
              <th>Tipo</th>
              <th>Estado</th>
              <th>Habilitacion</th>
              <th>Ultima modificacion</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of virtualRows">
              <td>{{ row.id || '-' }}</td>
              <td>{{ posTerminalOptionLabel(row.posTerminalId) }}</td>
              <td>{{ row.clientId || '-' }}</td>
              <td>{{ row.terminalId || '-' }}</td>
              <td>{{ row.terminalType || (row.posTerminalId ? 'CP' : 'CNP') }}</td>
              <td>
                <span class="badge" [class.success]="row.status === 'ONLINE'" [class.warning]="row.status !== 'ONLINE'">
                  {{ statusLabel(row.status) }}
                </span>
              </td>
              <td>
                <span class="badge" [class.success]="row.enabled" [class.danger]="!row.enabled">
                  {{ row.enabled ? 'Habilitada' : 'Deshabilitada' }}
                </span>
              </td>
              <td>{{ formatDate(row.updatedAt) }}</td>
              <td>
                <div class="row-actions">
                  <button class="action-button edit" type="button" title="Editar" (click)="openVirtualEdit(row)">✎</button>
                  <button class="action-button delete" type="button" title="Eliminar" (click)="deleteVirtual(row)">■</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!virtualRows.length && !tableLoading">
              <td colspan="9">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ virtualTotal }} terminales virtuales
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="virtualSize" (ngModelChange)="changeVirtualSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changeVirtualPage(virtualPage - 1)" [disabled]="virtualPage === 0">Anterior</button>
          <app-page-navigation [page]="virtualPage" [totalPages]="virtualTotalPages" [disabled]="tableLoading" (pageChange)="changeVirtualPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changeVirtualPage(virtualPage + 1)" [disabled]="virtualPage + 1 >= virtualTotalPages">Siguiente</button>
        </div>
      </div>

      <div class="section-divider"></div>

      <div class="crud-header">
        <div>
          <span class="eyebrow">PosVirtualTerminalMedioPagoRestController</span>
          <h3>Medios de pago por terminal virtual</h3>
        </div>
        <button class="primary-button add-button" type="button" (click)="openVirtualMedioPagoCreate()">+ Dar de alta</button>
      </div>

      <div class="crud-tools virtual-medio-tools">
        <input type="search" placeholder="Buscar por ID" [(ngModel)]="virtualMedioPagoSearchText" (keyup.enter)="applyVirtualMedioPagoFilters()">
        <input type="number" placeholder="ID" [(ngModel)]="virtualMedioPagoFilters['id']">
        <select [(ngModel)]="virtualMedioPagoFilters['pos_virutal_terminal_id']">
          <option value="">Terminal virtual</option>
          <option *ngFor="let terminal of virtualTerminalOptions" [ngValue]="terminal.id">{{ virtualTerminalOptionLabel(terminal.id) }}</option>
        </select>
        <input type="number" placeholder="Medio pago ID" [(ngModel)]="virtualMedioPagoFilters['medio_pago_id']">
        <button class="ghost-button" type="button" (click)="clearVirtualMedioPagoFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyVirtualMedioPagoFilters()">Filtrar</button>
      </div>

      <div class="table-wrap">
        <table class="crud-table virtual-medio-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Terminal virtual</th>
              <th>Medio pago ID</th>
              <th>Ultima modificacion</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of virtualMedioPagoRows">
              <td>{{ row.id || '-' }}</td>
              <td>{{ virtualTerminalOptionLabel(row.pos_virutal_terminal_id) }}</td>
              <td>{{ row.medio_pago_id || '-' }}</td>
              <td>{{ formatDate(row.updatedAt) }}</td>
              <td>
                <div class="row-actions">
                  <button class="action-button edit" type="button" title="Editar" (click)="openVirtualMedioPagoEdit(row)">✎</button>
                  <button class="action-button delete" type="button" title="Eliminar" (click)="deleteVirtualMedioPago(row)">■</button>
                </div>
              </td>
            </tr>
            <tr *ngIf="!virtualMedioPagoRows.length && !tableLoading">
              <td colspan="5">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ virtualMedioPagoTotal }} medios de pago
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="virtualMedioPagoSize" (ngModelChange)="changeVirtualMedioPagoSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changeVirtualMedioPagoPage(virtualMedioPagoPage - 1)" [disabled]="virtualMedioPagoPage === 0">Anterior</button>
          <app-page-navigation [page]="virtualMedioPagoPage" [totalPages]="virtualMedioPagoTotalPages" [disabled]="tableLoading" (pageChange)="changeVirtualMedioPagoPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changeVirtualMedioPagoPage(virtualMedioPagoPage + 1)" [disabled]="virtualMedioPagoPage + 1 >= virtualMedioPagoTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #configurationTab>
    <ng-container *ngIf="activeTab === 'configuration'; else submerchantTab">
      <div class="crud-tools configuration-tools">
        <input type="search" placeholder="Buscar por serial" [(ngModel)]="configurationSearchText" (keyup.enter)="applyConfigurationFilters()">
        <input type="number" placeholder="ID terminal" [(ngModel)]="configurationFilters['terminalId']">
        <input type="text" placeholder="Numero de serie" [(ngModel)]="configurationFilters['serialNumber']">
        <input type="text" placeholder="Version software" [(ngModel)]="configurationFilters['softwareVersion']">
        <select [(ngModel)]="configurationFilters['terminalStatus']">
          <option value="">Estado terminal</option>
          <option *ngFor="let status of statuses" [value]="status">{{ statusLabel(status) }}</option>
        </select>
        <select [(ngModel)]="configurationFilters['terminalEnabled']">
          <option value="">Habilitacion</option>
          <option value="true">Habilitadas</option>
          <option value="false">Deshabilitadas</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearConfigurationFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyConfigurationFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table configuration-table">
          <thead>
            <tr>
              <th>ID terminal</th>
              <th>Numero de serie</th>
              <th>Terminal virtual</th>
              <th>Cliente</th>
              <th>Software</th>
              <th>Estado POS</th>
              <th>Estado virtual</th>
              <th>Terminales Payway</th>
              <th>Ultima modificacion</th>
              <th>Detalle</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of configurationRows">
              <td>{{ terminalCode(row.terminalId) }}</td>
              <td>{{ row.serialNumber || '-' }}</td>
              <td>{{ row.virtualTerminalId || '-' }}</td>
              <td>{{ row.clientId || '-' }}</td>
              <td>{{ row.softwareVersion || '-' }}</td>
              <td>
                <span class="badge" [class.success]="row.terminalStatus === 'FUNCIONAL'" [class.warning]="row.terminalStatus !== 'FUNCIONAL'">
                  {{ statusLabel(row.terminalStatus) }}
                </span>
              </td>
              <td>
                <span class="badge" [class.success]="row.virtualStatus === 'ONLINE'" [class.warning]="row.virtualStatus && row.virtualStatus !== 'ONLINE'">
                  {{ statusLabel(row.virtualStatus) }}
                </span>
              </td>
              <td>{{ row.merchantTerminalCount ?? 0 }} / {{ listLabel(row.paywayTerminalIds) }}</td>
              <td>{{ formatDate(row.updatedAt) }}</td>
              <td><button class="ghost-button" type="button" (click)="openConfigurationDetail(row)">Ver</button></td>
            </tr>
            <tr *ngIf="!configurationRows.length && !tableLoading">
              <td colspan="10">Sin resultados</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status">
          <span class="loading-spinner" *ngIf="tableLoading"></span>
          {{ configurationTotal }} configuraciones
        </div>
        <label class="inline-control">
          Registros
          <select [(ngModel)]="configurationSize" (ngModelChange)="changeConfigurationSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changeConfigurationPage(configurationPage - 1)" [disabled]="configurationPage === 0">Anterior</button>
          <app-page-navigation [page]="configurationPage" [totalPages]="configurationTotalPages" [disabled]="tableLoading" (pageChange)="changeConfigurationPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changeConfigurationPage(configurationPage + 1)" [disabled]="configurationPage + 1 >= configurationTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #submerchantTab>
    <ng-container *ngIf="activeTab === 'submerchant'; else terminalGPTab">
      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>
      <div class="table-wrap">
        <table class="crud-table">
          <thead><tr><th>ID</th><th>Submerchant ID</th><th>CUIT</th><th>Razon social</th><th>Nombre comercial</th><th>Canal</th><th>Estado</th><th>Creado</th><th>Acciones</th></tr></thead>
          <tbody>
            <tr *ngFor="let row of submerchantRows">
              <td>{{ row.id || '-' }}</td><td>{{ row.submerchantId || '-' }}</td><td>{{ row.cuit || '-' }}</td>
              <td>{{ row.razonSocial || '-' }}</td><td>{{ row.nombreComercial || '-' }}</td>
              <td>{{ row.cardNotPresent ? 'CNP' : 'CP' }}</td><td>{{ row.status === 0 ? 'Activo' : 'Inactivo' }}</td>
              <td>{{ formatDate(row.createdAt) }}</td>
              <td><button class="action-button edit" type="button" title="Editar" (click)="openSubmerchantEdit(row)">✎</button></td>
            </tr>
            <tr *ngIf="!submerchantRows.length && !tableLoading"><td colspan="9">Sin resultados</td></tr>
          </tbody>
        </table>
      </div>
      <div class="pagination">
        <div class="pagination-status">{{ submerchantTotal }} submerchants</div>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changeSubmerchantPage(submerchantPage - 1)" [disabled]="submerchantPage === 0">Anterior</button>
          <app-page-navigation [page]="submerchantPage" [totalPages]="submerchantTotalPages" [disabled]="tableLoading" (pageChange)="changeSubmerchantPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changeSubmerchantPage(submerchantPage + 1)" [disabled]="submerchantPage + 1 >= submerchantTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #terminalGPTab>
    <ng-container *ngIf="activeTab === 'terminal-global-processing'; else pendingTab">
      <div class="crud-tools payway-tools">
        <input type="search" placeholder="Buscar por ID" [(ngModel)]="terminalGPSearchText" (keyup.enter)="applyTerminalGPFilters()">
        <input type="number" placeholder="ID" [(ngModel)]="terminalGPFilters['id']">
        <select [(ngModel)]="terminalGPFilters['posVirtualTerminalId']">
          <option value="">Terminal virtual</option>
          <option *ngFor="let terminal of virtualTerminalOptions" [ngValue]="terminal.id">{{ virtualTerminalOptionLabel(terminal.id) }}</option>
        </select>
        <select [(ngModel)]="terminalGPFilters['submerchantDataId']">
          <option value="">Submerchant</option>
          <option *ngFor="let submerchant of submerchantOptions" [ngValue]="submerchant.id">{{ submerchantOptionLabel(submerchant.id) }}</option>
        </select>
        <button class="ghost-button" type="button" (click)="clearTerminalGPFilters()">Limpiar</button>
        <button class="primary-button" type="button" (click)="applyTerminalGPFilters()">Filtrar</button>
      </div>

      <div class="state success-state" *ngIf="message">{{ message }}</div>
      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="table-wrap">
        <table class="crud-table payway-table">
          <thead><tr><th>ID</th><th>Terminal virtual</th><th>Submerchant</th><th>Alta</th><th>Ultima modificacion</th><th>Acciones</th></tr></thead>
          <tbody>
            <tr *ngFor="let row of terminalGPRows">
              <td>{{ row.id || '-' }}</td>
              <td>{{ virtualTerminalOptionLabel(row.posVirtualTerminalId) }}</td>
              <td>{{ submerchantOptionLabel(row.submerchantDataId) }}</td>
              <td>{{ formatDate(row.createdAt) }}</td>
              <td>{{ formatDate(row.updatedAt) }}</td>
              <td><div class="row-actions">
                <button class="action-button edit" type="button" title="Editar" (click)="openTerminalGPEdit(row)">✎</button>
                <button class="ghost-button" type="button" title="Desadherir submerchant" (click)="removeTerminalGPSubmerchant(row)" [disabled]="!row.submerchantDataId">Desadherir</button>
                <button class="action-button delete" type="button" title="Eliminar" (click)="deleteTerminalGP(row)">■</button>
              </div></td>
            </tr>
            <tr *ngIf="!terminalGPRows.length && !tableLoading"><td colspan="6">Sin resultados</td></tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-status"><span class="loading-spinner" *ngIf="tableLoading"></span>{{ terminalGPTotal }} terminales Global Processing</div>
        <label class="inline-control">Registros
          <select [(ngModel)]="terminalGPSize" (ngModelChange)="changeTerminalGPSize()">
            <option *ngFor="let option of pageSizes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <div class="pagination-actions">
          <button class="ghost-button" type="button" (click)="changeTerminalGPPage(terminalGPPage - 1)" [disabled]="terminalGPPage === 0">Anterior</button>
          <app-page-navigation [page]="terminalGPPage" [totalPages]="terminalGPTotalPages" [disabled]="tableLoading" (pageChange)="changeTerminalGPPage($event)"></app-page-navigation>
          <button class="ghost-button" type="button" (click)="changeTerminalGPPage(terminalGPPage + 1)" [disabled]="terminalGPPage + 1 >= terminalGPTotalPages">Siguiente</button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #pendingTab>
    <div class="state terminal-empty-state">
      <strong>{{ activeTabLabel }}</strong>
      <span>Seccion preparada para conectar el controller correspondiente.</span>
    </div>
  </ng-template>

  <div class="modal-backdrop" *ngIf="configurationDetail || configurationDetailLoading" (click)="closeConfigurationDetail()">
    <article class="modal transaction-detail-modal" (click)="$event.stopPropagation()">
      <header class="detail-header">
        <div>
          <span class="eyebrow">Detalle de configuracion</span>
          <h3>{{ configurationDetailRow?.serialNumber || '-' }} Â· {{ configurationDetailRow?.virtualTerminalId || '-' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeConfigurationDetail()">Cerrar</button>
      </header>

      <div class="state loading-state" *ngIf="configurationDetailLoading">
        <span class="loading-spinner" aria-hidden="true"></span>
        Cargando detalle...
      </div>

      <ng-container *ngIf="configurationDetail">
        <div class="detail-summary">
          <div>
            <span>ID</span>
            <strong>{{ detailText(configurationValue('id')) }}</strong>
          </div>
          <div>
            <span>Serial</span>
            <strong>{{ detailText(configurationValue('serialNumber')) }}</strong>
          </div>
          <div>
            <span>Habilitada</span>
            <strong>{{ detailText(configurationValue('enable')) }}</strong>
          </div>
        </div>

        <section *ngFor="let virtualTerminal of configurationVirtualTerminals()">
        <h3>Terminal virtual {{ detailText(detailObjectValue(virtualTerminal, 'terminalId')) }}</h3>

        <div class="detail-grid compact">
          <div class="detail-item">
            <div>
              <span>Cliente</span>
              <strong>{{ detailText(detailObjectValue(detailObjectValue(virtualTerminal, 'submerchantData'), 'clienteId')) }}</strong>
            </div>
          </div>
          <div class="detail-item">
            <div>
              <span>Razon social</span>
              <strong>{{ detailText(detailObjectValue(detailObjectValue(virtualTerminal, 'submerchantData'), 'legalName')) }}</strong>
            </div>
          </div>
          <div class="detail-item">
            <div>
              <span>Nombre fantasia</span>
              <strong>{{ detailText(detailObjectValue(detailObjectValue(virtualTerminal, 'submerchantData'), 'name')) }}</strong>
            </div>
          </div>
          <div class="detail-item">
            <div>
              <span>Tipo documento</span>
              <strong>{{ detailText(detailObjectValue(detailObjectValue(virtualTerminal, 'submerchantData'), 'documentType')) }}</strong>
            </div>
          </div>
          <div class="detail-item">
            <div>
              <span>Numero documento</span>
              <strong>{{ detailText(detailObjectValue(detailObjectValue(virtualTerminal, 'submerchantData'), 'documentNumber')) }}</strong>
            </div>
          </div>
          <div class="detail-item">
            <div>
              <span>MCC</span>
              <strong>{{ detailText(detailObjectValue(detailObjectValue(virtualTerminal, 'submerchantData'), 'mcc')) }}</strong>
            </div>
          </div>
          <div class="detail-item">
            <div>
              <span>Soft descriptor</span>
              <strong>{{ detailText(detailObjectValue(detailObjectValue(virtualTerminal, 'submerchantData'), 'softDescriptor')) }}</strong>
            </div>
          </div>
          <div class="detail-item">
            <div>
              <span>Domicilio</span>
              <strong>{{ detailText(detailObjectValue(detailObjectValue(virtualTerminal, 'submerchantData'), 'address')) }} {{ detailText(detailObjectValue(detailObjectValue(virtualTerminal, 'submerchantData'), 'doorNumber')) }}</strong>
            </div>
          </div>
        </div>

        <div class="section-divider"></div>

        <div class="table-wrap">
          <table class="crud-table configuration-detail-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Medio de pago</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let paymentMethod of detailChildArray(virtualTerminal, 'paymentMethodData')">
                <td>{{ detailText(detailObjectValue(paymentMethod, 'id')) }}</td>
                <td>{{ detailText(detailObjectValue(paymentMethod, 'paymentMethod')) }}</td>
              </tr>
              <tr *ngIf="detailChildArray(virtualTerminal, 'paymentMethodData').length === 0">
                <td colspan="2">Sin medios de pago configurados.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="section-divider"></div>

        <div class="table-wrap">
          <table class="crud-table configuration-detail-table">
            <thead>
              <tr>
                <th>Merchant ID</th>
                <th>Marca</th>
                <th>Proceso</th>
                <th>Cuotas</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let merchant of detailChildArray(virtualTerminal, 'merchantIdData')">
                <td>{{ detailText(detailObjectValue(merchant, 'merchantId')) }}</td>
                <td>{{ merchantBrandValue(merchant) }}</td>
                <td>{{ detailText(detailObjectValue(merchant, 'paymentProcessType')) }}</td>
                <td>
                  <span class="edit-chip" *ngFor="let installment of detailChildArray(merchant, 'installmentData')">
                    {{ detailText(detailObjectValue(installment, 'installmentNumber')) }} cuotas / {{ detailText(detailObjectValue(installment, 'installmentFactor')) }}
                  </span>
                  <span *ngIf="detailChildArray(merchant, 'installmentData').length === 0">{{ merchantBrandLabel(merchant) }}</span>
                </td>
              </tr>
              <tr *ngIf="detailChildArray(virtualTerminal, 'merchantIdData').length === 0">
                <td colspan="4">Sin merchant IDs configurados.</td>
              </tr>
            </tbody>
          </table>
        </div>
        </section>
      </ng-container>
    </article>
  </div>

  <div class="modal-backdrop" *ngIf="modalOpen">
    <form class="modal terminal-modal" (ngSubmit)="save()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditing ? 'Editar terminal' : 'Alta terminal POS' }}</span>
          <h3>{{ isEditing ? 'Actualizar terminal' : 'Nueva terminal' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeModal()">×</button>
      </header>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="terminal-form">
        <label>
          Serial
          <input type="text" name="serialNumber" [(ngModel)]="form.serialNumber">
        </label>
        <label>
          Version software
          <input type="text" name="softwareVersion" [(ngModel)]="form.softwareVersion">
        </label>
        <label>
          Estado de terminal
          <select name="terminalStatus" [(ngModel)]="form.terminalStatus">
            <option *ngFor="let status of statuses" [value]="status">{{ statusLabel(status) }}</option>
          </select>
        </label>
        <label>
          Habilitacion
          <select name="enabled" [(ngModel)]="form.enabled">
            <option [ngValue]="true">Habilitada</option>
            <option [ngValue]="false">Deshabilitada</option>
          </select>
        </label>
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSave || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="merchantModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="saveMerchant()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditingMerchant ? 'Editar merchant' : 'Alta merchant ID' }}</span>
          <h3>{{ isEditingMerchant ? 'Actualizar merchant ID' : 'Nuevo merchant ID' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeMerchantModal()">×</button>
      </header>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="terminal-form">
        <label>
          Cliente ID
          <app-client-select name="clientId" [(ngModel)]="merchantForm.clientId"></app-client-select>
        </label>
        <label>
          Merchant ID
          <input type="text" name="merchantId" [(ngModel)]="merchantForm.merchantId">
        </label>
        <label>
          Descripcion
          <input type="text" name="descripcion" [(ngModel)]="merchantForm.descripcion">
        </label>
        <label>
          MCC
          <input type="text" name="mcc" [(ngModel)]="merchantForm.mcc">
        </label>
        <label>
          Marca
          <select name="cardBrand" [(ngModel)]="merchantForm.cardBrand">
            <option *ngFor="let brand of cardBrands" [value]="brand">{{ brand }}</option>
          </select>
        </label>
        <label>
          Proceso
          <select name="paymentProcessType" [(ngModel)]="merchantForm.paymentProcessType">
            <option *ngFor="let type of paymentProcessTypes" [value]="type">{{ type }}</option>
          </select>
        </label>
        <label>
          Banco ID
          <input type="number" name="bankId" min="1" [(ngModel)]="merchantForm.bankId">
        </label>
        <label>
          Adquirente
          <select name="merchantAcquirer" [(ngModel)]="merchantForm.acquirer" [disabled]="!isEditingMerchant">
            <option *ngFor="let acquirer of acquirers" [value]="acquirer">{{ acquirer }}</option>
          </select>
        </label>
        <label>
          Habilitacion
          <select name="merchantEnabled" [(ngModel)]="merchantForm.enabled">
            <option [ngValue]="true">Habilitado</option>
            <option [ngValue]="false">Deshabilitado</option>
          </select>
        </label>
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeMerchantModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSaveMerchant || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="conditionModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="saveCondition()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditingCondition ? 'Editar condicion' : 'Alta condition fee' }}</span>
          <h3>{{ isEditingCondition ? 'Actualizar merchant condition fee' : 'Nuevo merchant condition fee' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeConditionModal()">×</button>
      </header>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="terminal-form">
        <label>
          Merchant ID
          <select name="posMerchantId" [(ngModel)]="conditionForm.posMerchantId">
            <option [ngValue]="null">Seleccionar merchant</option>
            <option *ngFor="let merchant of conditionMerchantOptions" [ngValue]="merchant.id">{{ merchantOptionLabel(merchant.id) }}</option>
          </select>
        </label>
        <label>
          Tipo de pago
          <select name="paymentType" [(ngModel)]="conditionForm.paymentType" (ngModelChange)="onConditionPaymentTypeChange()">
            <option value="">Seleccionar tipo</option>
            <option *ngFor="let option of paymentTypes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <label>
          Tipo de cuotas
          <select name="installmentType" [(ngModel)]="conditionForm.installmentType" [disabled]="isConditionInstallmentTypeFixed">
            <option value="">Seleccionar tipo</option>
            <option *ngFor="let option of installmentTypes" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
        <label>
          Tax
          <input type="number" name="tax" step="0.01" [(ngModel)]="conditionForm.tax">
        </label>
        <label>
          Fee
          <input type="number" name="fee" step="0.01" [(ngModel)]="conditionForm.fee">
        </label>
        <label>
          TNA
          <input type="number" name="tna" step="0.01" [(ngModel)]="conditionForm.tna">
        </label>
        <label>
          Bank fee
          <input type="number" name="bankFee" step="0.01" [(ngModel)]="conditionForm.bankFee">
        </label>
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeConditionModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSaveCondition || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="installmentModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="saveInstallment()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditingInstallment ? 'Editar installment' : 'Alta installment' }}</span>
          <h3>{{ isEditingInstallment ? 'Actualizar installment' : 'Nuevo installment' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeInstallmentModal()">×</button>
      </header>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="terminal-form">
        <label>
          Merchant Condition Fee
          <select name="installmentConditionFee" [(ngModel)]="installmentForm.posMerchantConditionFeeId">
            <option [ngValue]="null">Seleccionar merchant condition fee</option>
            <option *ngFor="let option of installmentConditionFeeOptions" [ngValue]="option.id">{{ conditionFeeMerchantLabel(option) }}</option>
          </select>
        </label>
        <label>
          Factor
          <input type="number" name="installmentFactor" step="0.0001" [(ngModel)]="installmentForm.installmentFactor">
        </label>
        <label>
          Nro cuotas
          <input type="number" name="installmentNumber" min="1" [(ngModel)]="installmentForm.installmentNumber">
        </label>
        <label>
          Inicio
          <input type="date" name="installmentStart" [(ngModel)]="installmentForm.start">
        </label>
        <label>
          Estado
          <select name="installmentEnable" [(ngModel)]="installmentForm.enable">
            <option [ngValue]="true">Habilitado</option>
            <option [ngValue]="false">Deshabilitado</option>
          </select>
        </label>
      </div>

      <div class="state" *ngIf="!installmentConditionFeeOptions.length">
        No hay merchant condition fee con cuotas habilitadas para seleccionar.
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeInstallmentModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSaveInstallment || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="planModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="savePlan()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditingPlan ? 'Editar plan' : 'Alta plan' }}</span>
          <h3>{{ isEditingPlan ? 'Actualizar plan' : 'Nuevo plan' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closePlanModal()">×</button>
      </header>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="terminal-form">
        <label>
          Condition fee
          <select name="planConditionFee" [(ngModel)]="planForm.posMerchantConditionFeeId">
            <option [ngValue]="null">Seleccionar condition fee</option>
            <option *ngFor="let option of installmentConditionFeeOptions" [ngValue]="option.id">{{ conditionFeeOptionLabel(option.id) }}</option>
          </select>
        </label>
        <label>
          Descripcion
          <input type="text" name="planDescription" [(ngModel)]="planForm.description">
        </label>
        <label>
          Inicio
          <input type="date" name="planStart" [(ngModel)]="planForm.start">
        </label>
        <label>
          Fin
          <input type="date" name="planEnding" [(ngModel)]="planForm.ending">
        </label>
        <label>
          Recargo (Opcional)
          <input type="number" name="planSurcharge" step="0.01" [(ngModel)]="planForm.surchargePercentage">
        </label>
        <label>
          Max financiacion (Opcional)
          <input type="number" name="planMaxFinancing" step="0.01" [(ngModel)]="planForm.maxFinancingAmount">
        </label>
        <div class="list-editor">
          <label>
            BIN
            <input type="text" name="planBinDraft" [(ngModel)]="planBinDraft" (keyup.enter)="addPlanBin()">
          </label>
          <button class="ghost-button" type="button" (click)="addPlanBin()">Agregar</button>
          <div class="chip-list">
            <span class="edit-chip" *ngFor="let bin of planForm.binList">
              {{ bin }}
              <button type="button" (click)="removePlanBin(bin)">×</button>
            </span>
          </div>
        </div>
        <div class="list-editor">
          <label>
            Dia
            <select name="planDayDraft" [(ngModel)]="planDayDraft">
              <option value="">Seleccionar dia</option>
              <option *ngFor="let day of weekDays" [value]="day">{{ statusLabel(day) }}</option>
            </select>
          </label>
          <button class="ghost-button" type="button" (click)="addPlanDay()">Agregar</button>
          <div class="chip-list">
            <span class="edit-chip" *ngFor="let day of planForm.dayList">
              {{ statusLabel(day) }}
              <button type="button" (click)="removePlanDay(day)">×</button>
            </span>
          </div>
        </div>
        <label>
          Estado
          <select name="planEnabled" [(ngModel)]="planForm.enabled">
            <option [ngValue]="true">Habilitado</option>
            <option [ngValue]="false">Deshabilitado</option>
          </select>
        </label>
        <label>
          Internacional
          <select name="planInternacional" [(ngModel)]="planForm.internacional">
            <option [ngValue]="true">Si</option>
            <option [ngValue]="false">No</option>
          </select>
        </label>
        <label>
          Cargo financiero cliente
          <select name="planClientCharge" [(ngModel)]="planForm.clientFinancialCharge">
            <option [ngValue]="true">Si</option>
            <option [ngValue]="false">No</option>
          </select>
        </label>
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closePlanModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSavePlan || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="planFactorModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="savePlanFactor()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditingPlanFactor ? 'Editar installment de plan' : 'Alta installment de plan' }}</span>
          <h3>{{ isEditingPlanFactor ? 'Actualizar installment de plan' : 'Nuevo installment de plan' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closePlanFactorModal()">×</button>
      </header>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="terminal-form">
        <label>
          Plan
          <select name="factorPlanId" [(ngModel)]="planFactorForm.posInstallmentsPlanId">
            <option [ngValue]="null">Seleccionar plan</option>
            <option *ngFor="let option of planOptions" [ngValue]="option.id">{{ planOptionLabel(option.id) }}</option>
          </select>
        </label>
        <label>
          Factor
          <input type="number" name="factorInstallmentFactor" step="0.0001" [(ngModel)]="planFactorForm.installmentFactor">
        </label>
        <label>
          Nro cuotas
          <input type="number" name="factorInstallmentNumber" min="1" max="99" [(ngModel)]="planFactorForm.installmentNumber">
        </label>
        <label>
          Texto comercial
          <input type="text" name="factorDisplayText" [(ngModel)]="planFactorForm.displayText">
        </label>
        <label>
          Estado
          <select name="factorEnabled" [(ngModel)]="planFactorForm.enabled">
            <option [ngValue]="true">Habilitado</option>
            <option [ngValue]="false">Deshabilitado</option>
          </select>
        </label>
      </div>

      <div class="state" *ngIf="!planOptions.length">
        No hay planes disponibles para seleccionar.
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closePlanFactorModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSavePlanFactor || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="assignPlanModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="saveAssignPlan()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditingAssignPlan ? 'Editar asignacion' : 'Alta asignacion' }}</span>
          <h3>{{ isEditingAssignPlan ? 'Actualizar asignacion de plan' : 'Asignar plan' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeAssignPlanModal()">×</button>
      </header>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="terminal-form">
        <label>
          Cliente ID
          <app-client-select name="assignPlanClientId" [(ngModel)]="assignPlanForm.clientId"></app-client-select>
        </label>
        <label>
          Plan
          <select name="assignPlanPlanId" [(ngModel)]="assignPlanForm.posInstallmentsPlanId">
            <option [ngValue]="null">Seleccionar plan</option>
            <option *ngFor="let option of planOptions" [ngValue]="option.id">{{ planOptionLabel(option.id) }}</option>
          </select>
        </label>
        <label>
          Estado
          <select name="assignPlanEnabled" [(ngModel)]="assignPlanForm.enabled">
            <option [ngValue]="true">Habilitado</option>
            <option [ngValue]="false">Deshabilitado</option>
          </select>
        </label>
      </div>

      <div class="state" *ngIf="!planOptions.length">
        No hay planes disponibles para asignar.
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeAssignPlanModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSaveAssignPlan || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="virtualModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="saveVirtual()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditingVirtual ? 'Editar terminal virtual' : 'Alta terminal virtual' }}</span>
          <h3>{{ isEditingVirtual ? 'Actualizar terminal virtual' : 'Nueva terminal virtual' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeVirtualModal()">×</button>
      </header>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="terminal-form">
        <label>
          Tipo
          <select name="virtualTerminalType" [(ngModel)]="virtualForm.terminalType" (ngModelChange)="onVirtualTerminalTypeChange()" required>
            <option *ngFor="let type of virtualTerminalTypes" [value]="type">{{ type }}</option>
          </select>
        </label>
        <label>
          POS terminal
          <select name="virtualPosTerminalId" [(ngModel)]="virtualForm.posTerminalId" [disabled]="virtualForm.terminalType === 'CNP'" [required]="virtualForm.terminalType === 'CP'">
            <option [ngValue]="null">Seleccionar POS habilitada</option>
            <option *ngFor="let terminal of availablePosTerminals" [ngValue]="terminal.id">{{ posTerminalOptionLabel(terminal.id) }}</option>
          </select>
        </label>
        <label>
          Cliente ID
          <app-client-select name="virtualClientId" [(ngModel)]="virtualForm.clientId"></app-client-select>
        </label>
        <label>
          Estado
          <select name="virtualStatus" [(ngModel)]="virtualForm.status">
            <option *ngFor="let status of virtualStatuses" [value]="status">{{ statusLabel(status) }}</option>
          </select>
        </label>
        <label>
          Habilitacion
          <select name="virtualEnabled" [(ngModel)]="virtualForm.enabled">
            <option [ngValue]="true">Habilitada</option>
            <option [ngValue]="false">Deshabilitada</option>
          </select>
        </label>
      </div>

      <div class="state" *ngIf="virtualForm.terminalType === 'CP' && !availablePosTerminals.length">
        No hay terminales POS habilitadas y funcionales para asociar.
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeVirtualModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSaveVirtual || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="submerchantModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="saveSubmerchant()" [attr.aria-busy]="submerchantSaving">
      <header>
        <div><span class="eyebrow">Global Processing</span><h3>{{ editingSubmerchant ? 'Modificar submerchant' : 'Nuevo submerchant' }}</h3></div>
        <button class="icon-button" type="button" (click)="closeSubmerchantModal()" [disabled]="submerchantSaving">×</button>
      </header>
      <div class="state error" *ngIf="error">{{ error }}</div>
      <fieldset class="terminal-form submerchant-fields" [disabled]="submerchantSaving">
        <label>Cliente ID<app-client-select [disabled]="submerchantSaving || !!editingSubmerchant" name="subClientId" [(ngModel)]="submerchantForm.clientId" (ngModelChange)="onSubmerchantClientChange($event)"></app-client-select></label>
        <div *ngIf="submerchantClientLoading" role="status">Completando datos del cliente...</div>
        <div *ngIf="submerchantClientError" role="alert" class="state error">
          {{ submerchantClientError }}
          <button type="button" (click)="onSubmerchantClientChange(submerchantForm.clientId)">Reintentar</button>
        </div>
        <div *ngIf="submerchantClientNotice" role="status">{{ submerchantClientNotice }}</div>
		<label>MCC<input type="number" name="subMcc" min="1000" max="9999" required [(ngModel)]="submerchantForm.submerchantDTO.mcc"></label>
		<label>CUIT<input type="number" name="subCuit" min="10000000000" max="99999999999" required [(ngModel)]="submerchantForm.submerchantDTO.cuit"></label>
        <label>Razon social<input type="text" name="subLegalName" maxlength="20" [ngModel]="submerchantForm.submerchantDTO.razonSocial" (input)="onSubmerchantNameInput('razonSocial', $event)"></label>
        <label>Nombre comercial<input type="text" name="subTradeName" maxlength="20" [ngModel]="submerchantForm.submerchantDTO.nombreComercial" (input)="onSubmerchantNameInput('nombreComercial', $event)"></label>
        <label>Soft descriptor (prefijo HPS*)<input type="text" name="subSoftDescriptor" maxlength="18" required [(ngModel)]="submerchantForm.submerchantDTO.softDescriptor"><small>Hasta 18 caracteres. Se guarda con el prefijo HPS*.</small></label>
        <label>Calle y numero<input type="text" name="subAddress" maxlength="50" [(ngModel)]="submerchantForm.submerchantDTO.calleNumero"></label>
		<label>CPA<input type="text" name="subPostalCode" minlength="8" maxlength="8" pattern="[A-Za-z][0-9]{4}[A-Za-z]{3}" placeholder="A9999AAA" title="CPA de 8 caracteres, por ejemplo C1425ABC" required [(ngModel)]="submerchantForm.submerchantDTO.codPostal" (ngModelChange)="onCpaChange($event)"></label>
		<label>Email comercio<input type="email" name="subEmail" maxlength="50" required [(ngModel)]="submerchantForm.submerchantDTO.mailComercio"></label>
		<label>Telefono<input type="number" name="subPhone" min="10000000" required [(ngModel)]="submerchantForm.submerchantDTO.telefono"></label>
		<label>URL sitio web {{ submerchantForm.cnp ? '(obligatoria)' : '(opcional)' }}<input type="text" name="subWebsite" maxlength="200" [required]="submerchantForm.cnp" [(ngModel)]="submerchantForm.submerchantDTO.urlSitioWeb"></label>
        <label>Provincia
          <select name="subProvince" [(ngModel)]="selectedProvinceId" (ngModelChange)="onProvinceChange()">
            <option [ngValue]="null">Seleccionar provincia</option><option *ngFor="let province of provinces" [ngValue]="province.id">{{ province.name }}</option>
          </select>
        </label>
        <label>Localidad
          <select name="subCity" [(ngModel)]="submerchantForm.idLocalidad" (ngModelChange)="onCityChange()">
			<option [ngValue]="null">Seleccionar localidad</option><option *ngFor="let city of cities" [ngValue]="city.id" [title]="city.name">{{ city.name }} ({{ city.postalCode }})</option>
          </select>
        </label>
        <label>Nombre titular<input type="text" name="subOwnerName" maxlength="30" [(ngModel)]="submerchantForm.submerchantDTO.nombreTitular"></label>
        <label>Apellido titular<input type="text" name="subOwnerSurname" maxlength="30" [(ngModel)]="submerchantForm.submerchantDTO.apellidoTitular"></label>
        <label>Tipo documento
          <select name="subDocumentType" [(ngModel)]="submerchantForm.submerchantDTO.tipoDocumento"><option [ngValue]="1">DNI</option><option [ngValue]="7">CUIL</option><option [ngValue]="8">CUIT</option></select>
        </label>
        <label>Documento<input type="number" name="subDocument" [(ngModel)]="submerchantForm.submerchantDTO.documentoTitular"></label>
		<label>Fecha nacimiento titular<input type="date" name="subBirthDate" [(ngModel)]="submerchantForm.submerchantDTO.fechaNacimientoTitular"></label>
        <label>Canal<select [disabled]="!!editingSubmerchant" name="subCnp" [(ngModel)]="submerchantForm.cnp"><option [ngValue]="false">Presencial (CP)</option><option [ngValue]="true">No presencial (CNP)</option></select></label>
        <label>Estado<select name="subStatus" [(ngModel)]="submerchantForm.submerchantDTO.estado"><option [ngValue]="0">Activo</option><option [ngValue]="1">Inactivo</option></select></label>
      </fieldset>
      <div class="submerchant-progress" *ngIf="submerchantSaving" role="status" aria-live="polite">
        <span class="loading-spinner" aria-hidden="true"></span>
        <span>{{ editingSubmerchant ? 'Guardando submerchant...' : submerchantForm.cnp ? 'Creando submerchant, merchant IDs y terminal CNP...' : 'Creando submerchant y merchant IDs...' }}</span>
      </div>
      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeSubmerchantModal()" [disabled]="submerchantSaving">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="submerchantSaving || !canSaveSubmerchant || !!loadingAction">{{ submerchantSaving ? 'Guardando...' : 'Guardar' }}</button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="virtualMedioPagoModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="saveVirtualMedioPago()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditingVirtualMedioPago ? 'Editar medio de pago' : 'Alta medio de pago' }}</span>
          <h3>{{ isEditingVirtualMedioPago ? 'Actualizar medio de pago' : 'Nuevo medio de pago por terminal virtual' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeVirtualMedioPagoModal()">×</button>
      </header>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="terminal-form">
        <label>
          Terminal virtual
          <select name="medioPagoVirtualTerminal" [(ngModel)]="virtualMedioPagoForm.pos_virutal_terminal_id">
            <option [ngValue]="null">Seleccionar terminal virtual</option>
            <option *ngFor="let terminal of virtualTerminalOptions" [ngValue]="terminal.id">{{ virtualTerminalOptionLabel(terminal.id) }}</option>
          </select>
        </label>
        <label>
          Medio pago ID
          <input type="number" name="medioPagoId" min="1" [(ngModel)]="virtualMedioPagoForm.medio_pago_id">
        </label>
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeVirtualMedioPagoModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSaveVirtualMedioPago || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="terminalPaywayModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="saveTerminalPayway()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditingTerminalPayway ? 'Editar Terminal Payway' : 'Alta Terminal Payway' }}</span>
          <h3>{{ isEditingTerminalPayway ? 'Actualizar Terminal Payway' : 'Nueva Terminal Payway' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeTerminalPaywayModal()">×</button>
      </header>

      <p class="state">Si la terminal virtual tiene GP asociado, Payway admite otras marcas, excepto Visa, Mastercard, American Express y Cabal.</p>

      <div class="state error" *ngIf="error">{{ error }}</div>

      <div class="terminal-form">
        <label>
          Terminal ID Payway
          <input type="text" name="paywayTerminalId" [(ngModel)]="terminalPaywayForm.terminalId">
        </label>
        <label>
          Terminal virtual
          <select name="paywayVirtualTerminal" [(ngModel)]="terminalPaywayForm.posVirtualTerminalId">
            <option [ngValue]="null">Seleccionar terminal virtual</option>
            <option *ngFor="let terminal of virtualTerminalOptions" [ngValue]="terminal.id">{{ virtualTerminalOptionLabel(terminal.id) }}</option>
          </select>
        </label>
        <label>
          Merchant ID
          <select name="paywayMerchantId" [(ngModel)]="terminalPaywayForm.posMerchantId">
            <option [ngValue]="null">Seleccionar merchant</option>
            <option *ngFor="let merchant of merchantOptions" [ngValue]="merchant.id">{{ merchantOptionLabel(merchant.id) }}</option>
          </select>
        </label>
      </div>

      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeTerminalPaywayModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSaveTerminalPayway || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>

  <div class="modal-backdrop" *ngIf="terminalGPModalOpen">
    <form class="modal terminal-modal" (ngSubmit)="saveTerminalGP()">
      <header>
        <div>
          <span class="eyebrow">{{ isEditingTerminalGP ? 'Editar Terminal Global Processing' : 'Alta Terminal Global Processing' }}</span>
          <h3>{{ isEditingTerminalGP ? 'Actualizar Terminal Global Processing' : 'Nueva Terminal Global Processing' }}</h3>
        </div>
        <button class="icon-button" type="button" (click)="closeTerminalGPModal()">×</button>
      </header>
      <div class="state error" *ngIf="error">{{ error }}</div>
      <div class="terminal-form">
        <label>Terminal virtual
          <select name="gpVirtualTerminal" [(ngModel)]="terminalGPForm.posVirtualTerminalId">
            <option [ngValue]="null">Seleccionar terminal virtual</option>
            <option *ngFor="let terminal of virtualTerminalOptions" [ngValue]="terminal.id">{{ virtualTerminalOptionLabel(terminal.id) }}</option>
          </select>
        </label>
        <label>Submerchant
          <select name="gpSubmerchant" [(ngModel)]="terminalGPForm.submerchantDataId">
            <option [ngValue]="null">Seleccionar submerchant</option>
            <option *ngFor="let submerchant of submerchantOptions" [ngValue]="submerchant.id">{{ submerchantOptionLabel(submerchant.id) }}</option>
          </select>
        </label>
      </div>
      <div class="header-actions">
        <button class="ghost-button" type="button" (click)="closeTerminalGPModal()">Cancelar</button>
        <button class="primary-button" type="submit" [disabled]="!canSaveTerminalGP || !!loadingAction">
          {{ loadingAction === 'create' ? 'Creando...' : loadingAction === 'update' ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>
</section>
